import {atom} from "recoil";
import {FormSearchPeakModel, PeakCreation} from "../api/types/peak";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";

export const initialPeakFilters: FormSearchPeakModel = {
    name: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    from: "",
    to: "",
    showOnlyActive: false,
    dealers: [],
    legalEntities: []
};
export const peakFiltersAtom = atom<FormSearchPeakModel>({
    key: "peakFiltersAtom",
    default: initialPeakFilters
});

export const initialPeakCreation: PeakCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false, false]
};
export const peakCreationAtom = atom({
    key: "peakCreationAtom",
    default: initialPeakCreation
});
